export default __webpack_public_path__ + "static/media/portfolio-lg-3.f8a54ebb.webp";